import { render, staticRenderFns } from "./setQuestionnaire.vue?vue&type=template&id=e5a7764a"
import script from "./setQuestionnaire.vue?vue&type=script&lang=js"
export * from "./setQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./setQuestionnaire.vue?vue&type=style&index=0&id=e5a7764a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports